import { render } from "./EmailCompromiseCheck.vue?vue&type=template&id=f4edeac4&scoped=true"
import script from "./EmailCompromiseCheck.vue?vue&type=script&lang=js"
export * from "./EmailCompromiseCheck.vue?vue&type=script&lang=js"

import "./EmailCompromiseCheck.vue?vue&type=style&index=0&id=f4edeac4&lang=css"
import "./EmailCompromiseCheck.vue?vue&type=style&index=1&id=f4edeac4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4edeac4"]])

export default __exports__